import React from 'react';
import PropTypes from 'prop-types';

import { RadioBulletMarker } from '../radio-bullet-marker';
import styles from './RadioBullet.css';

const IPropTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
  text: PropTypes.string,
};

const defaultProps = {
  className: '',
  onClick: () => {},
  selected: false,
  text: '',
};

const RadioBullet = props => (
  <button
    className={[
      styles.container,
      props.className,
      props.selected ? styles.selected : '',
    ].join(' ')}
    onClick={props.onClick}
  >
    <RadioBulletMarker
      className={styles.marker}
      selected={props.selected}
    />
    {props.text}
  </button>
);

RadioBullet.propTypes = IPropTypes;
RadioBullet.defaultProps = defaultProps;

export { RadioBullet };



// WEBPACK FOOTER //
// ./src/common/radio-bullet/RadioBullet.jsx